if (!window.__dawnCartDrawerTriggerInit) {
  window.__dawnCartDrawerTriggerInit = true;

  const CART_LINK_SELECTORS = [
    'a[href$="/cart"]',
    'a[href="/cart"]',
    'a[href*="/cart?"]',
    '.header__icon--cart',
    '.cart-icon-bubble',
    '[data-cart-trigger]',
    '[data-open-cart-drawer]'
  ];

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  function openDrawer() {
    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return false;

    if (cartDrawer.classList.contains('active')) return true;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }

    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    cartDrawer.classList.add('active');
    overlay?.classList.add('active');
    document.body.classList.add('overflow-hidden');

    return true;
  }

  function handleCartTriggerClick(event) {
    const trigger = event.target.closest(CART_LINK_SELECTORS.join(','));
    if (!trigger) return;
    if (trigger.matches('[data-cart-page-link], .ls-cart-view')) return;

    const href = trigger.getAttribute('href');
    const isCartLink = href && (href === '/cart' || href.endsWith('/cart') || href.includes('/cart?'));
    const isExplicitTrigger =
      trigger.matches('.header__icon--cart, .cart-icon-bubble, [data-cart-trigger], [data-open-cart-drawer]');

    if (!isCartLink && !isExplicitTrigger) return;
    if (isModifiedClick(event)) return;

    const opened = openDrawer();
    if (!opened) return;

    event.preventDefault();
    event.stopPropagation();
  }

  document.addEventListener('click', handleCartTriggerClick, true);
}
